import React, { useEffect, useState, useMemo } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./Email.css";
import { useDispatch, useSelector } from "react-redux";
import {
  sendEmailNotification,
  getUserData,
  scheduleEmail
} from "../../Redux/Actions/emailActions";
import SelectInput from "../../Global Functions/selectInput";
import {
  viewCityListPagination,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";

const ConfirmationModal = ({ message, onConfirm, onCancel }) => (
  <div className="modal-overlay">
    <div className="modal-content-copy">
      <p>{message}</p>
      <div className="modal-buttons">
        <button onClick={onConfirm} className="modal-yes-button">
          Yes
        </button>
        <button onClick={onCancel} className="modal-no-button">
          No
        </button>
      </div>
    </div>
  </div>
);

const ScheduleModal = ({ onClose, onSchedule }) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!date || !time) {
      alert("Please select both date and time");
      return;
    }
    onSchedule({ date, time });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-copy">
        <h3>Schedule Email</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Select Date:
            <input
              type="date"
              value={date}
              min={new Date().toISOString().split('T')[0]}
              onChange={e => setDate(e.target.value)}
              required
            />
          </label>
          <br />
          <label>
            Select Time:
            <input
              type="time"
              value={time}
              onChange={e => setTime(e.target.value)}
              required
            />
          </label>
          <br />
          <button type="submit" className="modal-yes-button">Schedule</button>
          <button type="button" onClick={onClose} className="modal-no-button">Cancel</button>
        </form>
      </div>
    </div>
  );
};

const EmailTemplates = () => {
  const dispatch = useDispatch();

  const [email_for, setEmail_for] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [imgResponseUrl, setImgResponseUrl] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [sendPayload, setSendPayload] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [html, setHtml] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);

  const [showScheduleModal, setShowScheduleModal] = useState(false);
  // const [scheduleDateTime, setScheduleDateTime] = useState(null);

  const { userData } = useSelector((state) => state.emailTemplates || {});
  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});

  const countryData = countryList?.data;
  const stateData = states?.data;
  const cityData = cities?.data;

  useEffect(() => {
      dispatch(viewCountryListPagination());
  }, [dispatch]);

  useEffect(() => {
    if (country) {
      dispatch(viewStateListPagination({ country }));
    }
    if (state) {
      dispatch(viewCityListPagination({ state, country }));
    }
  }, [dispatch, country, state]);

  useEffect(() => {
    if (!email_for) return;

    if (email_for === "user") {
      dispatch(
        getUserData({
          list_for: email_for,
          page: 1,
          limit: 1000,
          country_id: country || undefined,
          filter: searchTerm,
        })
      );
    } else {
      if (!country || !state || !city) return;
      dispatch(
        getUserData({
          list_for: email_for,
          page: 1,
          limit: 1000,
          country_id: country,
          state_id: state,
          city_id: city,
          filter: searchTerm,
        })
      );
    }
  }, [dispatch, email_for, country, state, city, searchTerm]);

  const users = useMemo(() => {
    return Array.isArray(userData?.data)
      ? userData.data.map((user) => ({
        name: user?.name || "",
        uid: String(user?.id || ""),
        id: user?._id || "",
      }))
      : [];
  }, [userData]);

  const options = ["user", "consultant", "builder"];

  const handleTypeChange = (value) => {
    setType((prev) => (prev === value ? "" : value));
  };

  const handleUserCheck = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const preparePayload = () => {
    const payload = {
      subject,
      message,
      type,
      email_for,
      html,
      list: selectedUsers,
    };

    if (imgResponseUrl) {
      payload.image = imgResponseUrl;
    }

    return payload;
  };

  const prepareAndShowConfirm = (e) => {
    e.preventDefault();
    setSendPayload(preparePayload());
    setShowConfirm(true);
  };

  const openScheduleModal = (e) => {
    e.preventDefault();
    setSendPayload(preparePayload());
    setShowScheduleModal(true);
  };

  const combineToUTCISO = (date, time) => {
    const localDateTime = new Date(`${date}T${time}:00`);
    return localDateTime.toISOString();
  };

  const handleScheduleSubmit = ({ date, time }) => {
    const payload = preparePayload();
    const schedule_at = combineToUTCISO(date, time);

    setShowScheduleModal(false);

    dispatch(scheduleEmail({ ...payload, schedule_at }))
      .then((res) => {
        if (res?.success) {
          toast.success("Email scheduled successfully");
          resetForm();
        } else {
          toast.error("Error scheduling email");
        }
      })
      .catch((error) => {
        toast.error("Error scheduling email");
      });
  };

  // const handleSchedule = async () => {
  //   if (!sendPayload || !scheduleDateTime) return;

  //   setIsSending(true);
  //   const res = await dispatch(scheduleEmail({ ...sendPayload, schedule_at: scheduleDateTime }));
  //   setIsSending(false);

  //   if (res?.success) {
  //     toast.success("Email scheduled successfully");
  //   } else {
  //     toast.error("Error scheduling email");
  //   }

  //   resetForm();
  // };

  const handleConfirmYes = async () => {
    setShowConfirm(false);
    if (!sendPayload) return;

    setIsSending(true);
    const res = await dispatch(sendEmailNotification(sendPayload));
    setIsSending(false);

    if (res?.success) {
      toast.success("Email sent");
    } else {
      toast.error("Error sending email");
    }

    resetForm();
  };

  const isFormValid = () => {
    if (!email_for) return false; 
    if (!country) return false;   
    if ((email_for === "builder" || email_for === "consultant") && (!state || !city)) return false;
    if (!subject || subject.trim() === "") return false;  
    if ((!message || message.trim() === "") && (!html || html.trim() === "")) return false;  
    if (!message) return false;
    if (!type) return false;
    if (type === "selected" && selectedUsers.length === 0) return false;  
    return true;
  };


  const handleConfirmNo = () => {
    setShowConfirm(false);
    setSendPayload(null);
  };

  const resetForm = () => {
    setEmail_for("");
    setState("");
    setCountry("");
    setCity("");
    setSubject("");
    setMessage("");
    setType("");
    setImgResponseUrl("");
    setSelectedUsers([]);
    setSearchTerm("");
    setSendPayload(null);
    setHtml("");
    // setScheduleDateTime(null);
  };

  // const handleRecipientChange = (value) => {
  //   setRecipient(prev => (prev === value ? '' : value));
  // };

  return (
    <MainLayout>
      <div className="notification-outlet">
        <div className="notification-header">
          <div className="notification-heading">
            <h2>Email Templates</h2>
            <div className="email-action-buttons">
              <button
                onClick={openScheduleModal}
                className="notification-send-button"
                disabled={!isFormValid() || isSending}
              >
                {isSending ? "Scheduling..." : "Schedule"}
              </button>
              <button
                onClick={prepareAndShowConfirm}
                className="notification-send-button"
                disabled={!isFormValid() || isSending}
              >
                {isSending ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        </div>
        <span>Create an Email to send to your users</span>
        <div className="notification-body">
          <div className="notification-body-left">
            <div className="form-group custom-select">
              <SelectInput
                name="email_for"
                value={email_for}
                placeholder="Select an option"
                label={<span>
                  Type<span style={{ color: "red" }}>*</span>
                </span>}
                options={options.map((option) => ({ label: option }))}
                onChange={(e) => setEmail_for(e.target.value)}
              />
            </div>
            <div className="form-group custom-select">
              <SelectInput
                name="country"
                value={country}
                placeholder="Select an option"
                label={<span>
                  Country<span style={{ color: "red" }}>*</span>
                </span>}
                options={
                  countryData?.map((country) => ({
                    label: country.country_name,
                    value: country._id,
                  })) || []
                }
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>
            {(email_for === "builder" || email_for === "consultant") && (
              <>
                <div className="form-group custom-select">
                  <SelectInput
                    disabled={!country}
                    required
                    name="State"
                    value={state}
                    placeholder="Select An Option"
                    label="State"
                    options={
                      stateData?.map((state) => ({
                        label: state.state_name,
                        value: state._id,
                      })) || []
                    }
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>
                <div className="form-group custom-select">
                  <SelectInput
                    disabled={!state}
                    required
                    name="City"
                    value={city}
                    placeholder="Select An Option"
                    label="City"
                    options={
                      cityData?.map((city) => ({
                        label: city.city_name,
                        value: city._id,
                      })) || []
                    }
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
              </>
            )}
            <hr />
            <h2>Email Details</h2>
            <div className="form-group">
              <label>
                Email Subject<span style={{ color: "red" }}>*</span> <span>(Max 60 characters)</span>
              </label>
              <input
                type="text"
                placeholder="Enter Subject"
                required
                maxLength={60}
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>
                Email Message<span style={{ color: "red" }}>*</span> <span>(Max 500 characters)</span>
              </label>
              <textarea
                rows={4}
                required
                placeholder="Enter message"
                maxLength={500}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="form-group" style={{ width: "197%", height: "25%" }}>
              <label>HTML Content<span style={{ color: "red" }}>*</span></label>
              <textarea
                rows={6}
                placeholder="Enter HTML content"
                value={html}
                onChange={(e) => setHtml(e.target.value)}
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
          <div className="notification-body-right">
            <div>
              <h2>Select Recipients</h2>
              <span>Select who will receive this email</span>
            </div>
            <hr />
            <h4>Select Recipients</h4>
            <label>
              <input
                type="checkbox"
                checked={type === "all"}
                onChange={() => handleTypeChange("all")}
              />
              All Users
            </label>
            <br />
            <div className="custom-selection-wrapper">
              <label className={!email_for || !country ? 'disabled-label' : ''}>
                <input
                  type="checkbox"
                  checked={type === "selected"}
                  onChange={() => handleTypeChange("selected")}
                  disabled={!email_for || !country}
                />
                Custom Selection
              </label>
              {(!email_for || !country) && (
                <small className="selection-hint">
                  {!email_for ? 'Please select Type first' : 'Please select Country'}
                </small>
              )}
            </div>
            {type === "selected" && (
              <div className="custom-selection-notification">
                <div className="custom-selection-div">
                  <label>Select Users</label>
                  <input
                    type="text"
                    placeholder="Search by name or UID"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="user-search-input"
                  />
                </div>
                <h4 className="notification-selection-heading">
                  <span>Name</span>
                  <span>UID</span>
                </h4>
                <ul className="search-results">
                  {users.length > 0 ? (
                    users.map((user, index) => (
                      <li key={index} className="user-list-item">
                        <label className="custom-user-label">
                          <input
                            type="checkbox"
                            value={user.id}
                            onChange={() => handleUserCheck(user.id)}
                            checked={selectedUsers.includes(user.id)}
                          />
                          <div className="user-info">
                            <span>{user.name}</span>
                            <span className="uid">{user.uid}</span>
                          </div>
                        </label>
                      </li>
                    ))
                  ) : (
                    <li>No users found</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        {showConfirm && (
          <ConfirmationModal
            message="Are you sure you want to send this email?"
            onConfirm={handleConfirmYes}
            onCancel={handleConfirmNo}
          />
        )}
        {showScheduleModal && (
          <ScheduleModal
            onClose={() => setShowScheduleModal(false)}
            onSchedule={handleScheduleSubmit}
          />
        )}
      </div>
    </MainLayout>
  );
};

export default EmailTemplates;

//